import React, { useState, useContext, useEffect } from "react";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { Form } from "react-bootstrap";
import { Button } from "react-bootstrap";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import loginBg from "url:./assets/images/background/login-register.jpg";
import logoIcon from 'url:./assets/images/logo-white.png';
import logoText from 'url:./assets/images/logo-text.png';
import CMDLogo from 'url:./assets/images/CMD-Passport.jpg';
import './dist/css/pages/login-register-lock.css';
import './dist/css/style.min.css';
import { UserContext } from "./UserContext";
import { login } from "./userSlice";
import { useDispatch, useSelector } from "react-redux";
const cardCSS = {
    marginTop: "20%",
    padding: "25px"
};
const Login = () => {
  const [email, setUserName] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
const isLoggedIn = useSelector((state) => state.user.isLoggedIn);
const dispatch = useDispatch();
  const navigate = useNavigate();
  //console.log(isLoggedIn);
useEffect(() => {
    if (isLoggedIn) {
      navigate("/newdashboard");
    }
  }, [isLoggedIn, navigate]);
    const { setUserData } = useContext(UserContext);
    const baseUrl = process.env.REACT_APP_BASE_URL;
  const handleLogin = async () => {
    setError(''); // clear old errors
    if (!email || !password) {
      setError('Username and password are required.');
      return;
    }

    try {
      const response = await axios.post(baseUrl+'auth/login', {
        email,
        password
      });
      //console.log(response.data.user); return false;

      const { token, user: userInfo } = response.data;

      const userData = {
        email,
        token,
        id: userInfo.id,
        role: userInfo.role,
      };

      dispatch(login(userData));

      localStorage.setItem('authToken', token);
      setUserData(response.data.user.id);
      localStorage.setItem('userId', response.data.user.id);
      localStorage.setItem('role', response.data.user.role);
      navigate('/newdashboard', { replace: true });
      console.log('Login successful');
    } catch (err) {
        console.log(err);
      //setError('Invalid Credentials!!');
    }
  };
  return (
    <div
      className="d-flex justify-content-center align-items-center"
      style={{ height: '100vh' }} // full viewport height
    >
    <section id="wrapper" className="login-register login-sidebar">
        <div style={{width: "100%", float: "left"}}><div style={{overflow: "hidden", width: "100%", aspectRatio: "16/9", pointerEvents: "none"}}>
    <div style={{backgroundColor:"rgb(255, 255, 255, 0.7)", position: "absolute", bottom: 0, padding: "10px 10px 10px 25%", width: "100%", fontWeight: "bold"}}>Developed by SAP MM Team KCCL</div>
    <iframe style={{width: "70%", height: "100%", objectFit: "cover", width: "100%", height: "100%"}} src="https://www.youtube.com/embed/17ubttje9D0?autoplay=1&mute=1&loop=1&controls=0&showinfo=0&autohide=1&playlist=17ubttje9D0" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
</div></div>
        <div className="login-box card">
            <div className="card-body" style={cardCSS}>
                <form className="form-horizontal form-material text-center" id="loginform"  onSubmit={(e) => {
    e.preventDefault(); // prevent page reload
    handleLogin();      // trigger login logic
  }}>
                    <a href="javascript:void(0)" className="db"><img src={logoIcon} alt="Home" style={{width: "700px", textAlign: "center", marginLeft: "35%", marginBottom: "15px"}} /></a>
                    <div style={{color:"red"}}>{error ? error : ""}</div>
                    <div className="form-group m-t-10">
                        <div className="col-xs-12">
                            <input className="form-control" type="text" required="" placeholder="Username" value={email}
                onChange={(e) => setUserName(e.target.value)} />
                        </div>
                    </div>
                    <div className="form-group">
                        <div className="col-xs-12">
                            <input className="form-control" type="password" required="" placeholder="Password" value={password}
                onChange={(e) => setPassword(e.target.value)} />
                        </div>
                    </div>
                    {/* <div className="form-group row">
                        <div className="col-md-12">
                            <div className="d-flex no-block align-items-center">
                                <div className="form-check">
                                    <input type="checkbox" className="form-check-input" id="customCheck1" />
                                    <label className="form-check-label">Remember me</label>
                                </div> 
                                <div className="ms-auto">
                                    <a href="javascript:void(0)" id="to-recover" className="text-muted"><i className="fas fa-lock m-r-5"></i> Forgot pwd?</a> 
                                </div>
                            </div>   
                        </div>
                    </div> */}
                    <div className="form-group text-center m-t-20">
                        <div className="col-xs-12">
                            <button className="btn btn-info btn-lg w-100 text-uppercase btn-rounded text-white" type="submit">Log In</button>
                        </div>
                    </div>
                    {/* <div className="row">
                        <div className="col-xs-12 col-sm-12 col-md-12 m-t-10 text-center">
                            <div className="social">
                                <button className="btn  btn-facebook" data-bs-toggle="tooltip" title="Login with Facebook"> <i aria-hidden="true" className="fab fa-facebook-f"></i> </button>
                                <button className="btn btn-googleplus" data-bs-toggle="tooltip" title="Login with Google"> <i aria-hidden="true" className="fab fa-google-plus-g"></i> </button>
                            </div>
                        </div>
                    </div>
                    <div className="form-group m-b-0">
                        <div className="col-sm-12 text-center">
                            Don't have an account? <a href="pages-register2.html" className="text-primary m-l-5"><b>Sign Up</b></a>
                        </div>
                    </div> */}
                </form>
                {/* <form className="form-horizontal" id="recoverform" action="https://eliteadmin.themedesigner.in/demos/bt4/horizontal-nav-fullwidth/index.html">
                    <div className="form-group ">
                        <div className="col-xs-12">
                            <h3>Recover Password</h3>
                            <p className="text-muted">Enter your Email and instructions will be sent to you! </p>
                        </div>
                    </div>
                    <div className="form-group ">
                        <div className="col-xs-12">
                            <input className="form-control" type="text" required="" placeholder="Email" />
                        </div>
                    </div>
                    <div className="form-group text-center m-t-20">
                        <div className="col-xs-12">
                            <button className="btn btn-primary btn-lg w-100 text-uppercase waves-effect waves-light" type="submit">Reset</button>
                        </div>
                    </div>
                </form> */}
            </div>
        </div>
    </section>
    </div>
  );
}

export default Login;